import React, { Fragment } from 'react'
import styled from 'styled-components'
import Colors from '../../constants/Colors'
import { SubH1 } from '../../components/FontStyle'
import { IconBin } from '../../constants/icons'

const Upload = ({ lotteries, handleClickRemoveSomeLottery }) => {
  return (
    <Fragment>
      {lotteries.length > 0 && (
        <UploadContent>
          <SubH1>ลอตเตอรี่ที่เพิ่มเข้ามา ทั้งหมด {lotteries.length} ใบ</SubH1>
          <div className="lottery-content">
            {lotteries.map((lotto, index) => {
              return (
                <div key={lotto.url} onClick={() => handleClickRemoveSomeLottery(index)} className="lottery-box" >
                  <span className="lottery-icon-box">
                    <IconBin fill={Colors.WHITE} />
                  </span>
                  <div className="lottery-overlay" />
                  <img className="lottery-image" src={lotto.url} alt="img lottery" />
                </div>
              )
            })}
          </div>
        </UploadContent>
      )}
    </Fragment>
  )
}

export default Upload

const UploadContent = styled.div`
  .lottery-content {
    margin-top: 24px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .lottery-box {
    border-radius: 8px;
    width: 24%;
    height: 24%;
    margin-bottom: 24px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${Colors.LIGHT_GREY2};

      .lottery-icon-box {
        position: absolute;
        display: none;
        z-index: 1;
      }

      .lottery-overlay {
        display: none;
        border-radius: 8px;
        opacity: 0.5;
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: ${Colors.SUPER_BLACK};
      }

      .lottery-image {
        width: 100%;
        border-radius: 8px;
      }

      &:hover {
        cursor: pointer;

        .lottery-icon-box {
          display: block;
        }

        .lottery-overlay {
          display: block;
        }
      }
    }
  }
`